"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nbd = void 0;
exports.nbd = {
    green70: "#0F572C",
    green50: "#1F8648",
    green45: "#67AD82",
    green40: "#97C6A9",
    green30: "#AFD3BD",
    green20: "#DFEDE4",
    green10: "#F7FAF7",
};
//# sourceMappingURL=nbd.js.map